<script>
export default {
    props: ["isFullSearchInput"],
    data() {
        return {
            searchTerm: ""
        };
    },
    methods: {
        openSearch() {
            this.$store.commit("toggleSearch", true);
            setTimeout(() => {
                this.searchTerm = "";
            }, 200);
        }
    },
    watch: {
        searchTerm(val) {
            this.$store.commit("searchTerm", val);
        }
    }
};
</script>

<template>
    <div class :class="isFullSearchInput ? 'flex-1' : ''">
        <transition appear mode="out-in" name="fade">
            <div
                class="bg-white border rounded overflow-hidden flex flex-row items-center py-3 px-4 h-full shadow text-grey hover:text-purple leading-tight"
                v-if="isFullSearchInput"
                style=""
            >
                <label
                    :for="`search-${_uid}`"
                    :id="`searchlabel-${_uid}`"
                    class="text-sm text-grey"
                    aria-label="What are you looking for?"
                >What are you looking for?</label>
                <input
                    :id="`search-${_uid}`"
                    :aria-labelledby="`searchlabel-${_uid}`"
                    type="search"
                    class="bg-transparent focus:outline-none btn-pad h-full text-sm flex-1"
                    v-model="searchTerm"
                    @focus="openSearch"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="w-5 h-5 fill-current mw-100"
                    >
                        <path
                            d="M9 18c2.13 0 4.09-.75 5.63-2l7.66 7.7a1 1 0 1 0 1.42-1.4l-7.67-7.71A9.01 9.01 0 1 0 0 9c0 4.96 4.04 9 9 9zM9 2a7 7 0 1 1-.02 14.02A7 7 0 0 1 9 2z"
                        ></path>
                        <g>
                            <path fill="none" d="M0 0h24v24H0z"></path>
                        </g>
                    </svg>
            </div>

            <button
                class="bg-white rounded overflow-hidden flex flex-row items-center justify-center btn-pad shadow-lg hover:shadow-xl text-grey hover:text-purple border-1 border-white p-3 mr-4"
                title="What are you looking for?"
                v-if="!isFullSearchInput"
                @click="openSearch"
            >
                <span class="block w-4 h-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="w-4 h-4 fill-current"
                    >
                        <path
                            d="M9 18c2.13 0 4.09-.75 5.63-2l7.66 7.7a1 1 0 1 0 1.42-1.4l-7.67-7.71A9.01 9.01 0 1 0 0 9c0 4.96 4.04 9 9 9zM9 2a7 7 0 1 1-.02 14.02A7 7 0 0 1 9 2z"
                        ></path>
                    </svg>
                </span>
            </button>
        </transition>
    </div>
</template>
<style scoped>
/*  */
</style>
